import { useMutation, useQueryCache } from 'react-query';
import { EventAPI } from 'api/admin/event';
import { EVENTS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateEvent() {
  const queryCache = useQueryCache();

  return useMutation(EventAPI.updateEvent, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(EVENTS);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
